import { Translator } from '@/types/translator.type';

export const CIRCUIT_STEPS = (t: Translator) => [
  t('circuits.steps.configuration'),
  t('circuits.steps.stepsAndEditorial'),
  t('circuits.steps.pricing'),
  t('circuits.steps.description'),
  t('circuits.steps.detailsAndOptions'),
];

export const DISTRIBUTOR_CIRCUIT_STEPS = (t: Translator) => [
  t('distributorCircuits.view.steps.description'),
  t('distributorCircuits.view.steps.detailsAndOptions'),
];
